export default __webpack_public_path__ + "static/media/packages.fd129ee4.svg";